module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/discount-4a5a521149377e67d50a140be0b2b3ae.webp";